import { SelectFieldBinder } from '../../binders/daq';
import { Gizmo } from '../../gizmos';
import { IGizmoCatalogOptionV2, IGizmoData } from '../../types';

interface IParams {
  variable: string;
  data: IGizmoData[];
  context: {
    answerGizmo: Gizmo;
  };
}

/**
 * Solve the influx variable with the select field when it has 'isMultiple' option set
 * to true
 *
 * @param {string} variable influx variable
 * @param {IGizmoData} data gizmo's data
 *
 * @returns
 */
function selectMultipleValues({ variable, data, context }: IParams) {
  const { answerGizmo } = context;
  const [uid, ...accesor] = variable.split('.');

  if (uid && accesor.length === 0 && data && Array.isArray(data)) {
    const values: string[] = [];

    for (const d of data) {
      if (d.v && typeof d.v === 'string') {
        values.push(d.v);
      }
    }

    return values;
  } else if (uid && accesor[0] === 'accepted' && data && Array.isArray(data)) {
    const values: (string | IGizmoCatalogOptionV2)[] = [];

    for (const d of data) {
      if (d.v && typeof d.v === 'string' && d.sod?.checked === true) {
        if (accesor[1] === 'options') {
          values.push(d.sod);
        } else {
          values.push(d.v);
        }
      }
    }

    return values;
  } else if (uid && accesor[0] === 'rejected' && data) {
    const values: (string | IGizmoCatalogOptionV2)[] = [];

    for (const d of data) {
      if (d.v && typeof d.v === 'string' && d.sod?.checked === false) {
        if (accesor[1] === 'options') {
          values.push(d.sod);
        } else {
          values.push(d.v);
        }
      }
    }

    return values;
  } else if (uid && accesor[0] === 'selected' && data) {
    const values = [];

    for (const d of data) {
      if (d.v && typeof d.v == 'string') {
        if (accesor[1] === 'options' && d.sod) {
          values.push(d.sod);
        } else {
          values.push(d.v);
        }
      }
    }

    return values;
  } else if (uid && accesor[0] === 'all_accepted' && data && answerGizmo) {
    const binder: SelectFieldBinder = answerGizmo.getBinder();
    const totalOptions = binder.getOptions().length;
    let totalAccepted = 0;

    for (const d of data) {
      if (d.v && typeof d.v === 'string' && d.sod?.checked === true) {
        totalAccepted += 1;
      }
    }

    return totalOptions === totalAccepted;
  } else if (uid && accesor[0] === 'all_rejected' && data && answerGizmo) {
    const binder: SelectFieldBinder = answerGizmo.getBinder();
    const totalOptions = binder.getOptions().length;
    let totalRejected = 0;

    for (const d of data) {
      if (d.v && typeof d.v === 'string' && d.sod?.checked === false) {
        totalRejected += 1;
      }
    }

    return totalOptions === totalRejected;
  } else if (uid && accesor[0] === 'all_selected' && data && answerGizmo) {
    const binder: SelectFieldBinder = answerGizmo.getBinder();
    const totalOptions = binder.getOptions().length;
    let totalSelected = 0;

    for (const d of data) {
      if (d.v && typeof d.v === 'string') {
        totalSelected += 1;
      }
    }

    return totalOptions === totalSelected;
  }

  return undefined;
}

export default selectMultipleValues;
